import { render } from "./App.vue?vue&type=template&id=731a20c4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Goya/components/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "731a20c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('731a20c4', __exports__)) {
    api.reload('731a20c4', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=731a20c4", () => {
    api.rerender('731a20c4', render)
  })

}


export default __exports__